import { useLocation } from 'react-router';

const useOnPaymentPage = function useOnPaymentPage(): boolean {
  const { pathname } = useLocation();
  return pathname.endsWith('/payment');
};

export default useOnPaymentPage;
